export const MenuSuperAdmin = [
  {
    title: "Credencial",
    iconStyle: <i className="material-icons">home</i>,
    to: "/afiliado/",
  },
  {
    title: "Editar afiliacion",
    iconStyle: <i className="material-icons"> receipt </i>,
    to: "/afiliado/edit-afiliado",
  },
  
  // {
  //   title: "Editar afiliacion",
  //   iconStyle: <i className="material-icons"> receipt </i>,
  //   to: "editar-Afiliacion",
  // },

];



